import axios from 'axios'
import api from '@/api'

export const homeModule = {
    namespaced: true,

    state:() => ({
        notifications: [],
        users: null,
        reviews: null
    }),

    mutations: {
        setNotifications(state, data) {
            state.notifications = data
        },

        setUsers(state, data) {
            state.users = data
        },

        setReviews(state, data) {
            state.reviews = data
        }
    },

    actions: {
        async getShop ({ commit, rootState }) {
            rootState.isLoading = true

            try {
                const response = await axios.get(api + "projects/tcode/products/", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
            } catch (err) {
                alert(err)
            }

            rootState.isLoading = false
        },

        async getReviews ({ commit }) {
            try {
                const response = await axios.get(api + "projects/tubatay/metrics/", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                commit('setReviews', response.data)
            } catch (err) {
                alert(err)
            }
        },

        async getDashboardChart({}) {
            return axios
            .get(`${api}dashboard/charts/tcode/main/`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },
    }
}